import { render, staticRenderFns } from "./uploadDesignImg.vue?vue&type=template&id=553aa9c3&"
import script from "./uploadDesignImg.vue?vue&type=script&lang=js&"
export * from "./uploadDesignImg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/design/uploadDesignImg.vue"
export default component.exports